// extracted by mini-css-extract-plugin
module.exports = {"description-text-panel":"styles-module__description-text-panel___LuvUb"};